import { Component, OnInit } from '@angular/core';
import { MessagingService } from '../../services/messaging.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css']
})
export class NotificationsComponent implements OnInit {

  messagingSubscription: any;

  isOpen: boolean = false;
  unreadCount: number = 0;

  notificationList: any[] = [];
  notificationSettings: any = {
    muted: false,
  };

  constructor(
    private messagingService: MessagingService,
  ) { }

  ngOnInit() {

    //var notificationStorageSetting = localStorage.getItem('Notification_muted');

    this.initNotificationSettings();

    var notifications = localStorage.getItem('Notification_items');

    if (notifications) {
      this.notificationList = JSON.parse(notifications);
    }

    this.markNotificationsAsRead();

    this.messagingSubscription = this.messagingService.componentMessageCall
      .subscribe(response => {
        let event = response.event;
        let eventData = response.data;

        if (event === "NOTIFICATION_UPDATE_LIST") {
          this.handleListUpdate();
        }

        //if (event === "SOCKET_NOTIFICATION") {
        //  this.notificationList.push({
        //    id: this.notificationList.length,
        //    notificationMessage: eventData.message,
        //    isRead: this.isOpen,
        //  });

        //  localStorage.setItem('Notification_items', JSON.stringify(this.notificationList));

        //  if (!this.isOpen) {
        //    this.unreadCount++;
        //  }

        //  if (!this.muted) {
        //    this.playNotificationSound();
        //  }          
        //}
      });
  }

  markNotificationsAsRead() {
    this.notificationList.forEach(notification => {
      notification.isRead = true;
    });
    localStorage.setItem('Notification_items', JSON.stringify(this.notificationList));
    this.messagingService.sendComponentMessage("HEADER_UPDATE_NOTIFICATION_LIST", []);

  }

  initNotificationSettings() {
    var notificationSettings = localStorage.getItem('Notification_settings');
    if (notificationSettings) {
      this.notificationSettings = JSON.parse(notificationSettings);
    } else {
      localStorage.setItem('Notification_settings', JSON.stringify(this.notificationSettings));
    }
  }

  handleListUpdate() {
    var listString = localStorage.getItem('Notification_items');
    this.notificationList = JSON.parse(listString);
  }

  markNotificationAsRead(notificationItem) {
    notificationItem.isRead = true;
    localStorage.setItem('Notification_items', JSON.stringify(this.notificationList));
    this.messagingService.sendComponentMessage("HEADER_UPDATE_NOTIFICATION_LIST", []);
  }

  toggleMute() {
    this.notificationSettings.muted = !this.notificationSettings.muted;
    localStorage.setItem('Notification_settings', JSON.stringify(this.notificationSettings));
    this.sendSettingsUpdate();
  }

  sendSettingsUpdate() {
    this.messagingService.sendComponentMessage('HEADER_UPDATE_NOTIFICATION_SETTINGS', {});
  }

  playNotificationSound() {
    let audio = new Audio();
    audio.src = '../../../assets/sounds/notification.wav';
    audio.load();
    audio.play();
  }

  toggleCloseStatus(isOpen: boolean) {
    console.log('this was called');
    this.isOpen = isOpen;
    if (this.isOpen) {
      this.notificationList.forEach(item => {
        item.isRead = true;
      });
      this.unreadCount = 0;
    }
  }
  
  clear() {
    this.notificationList = [];
    this.unreadCount = 0;
    localStorage.setItem('Notification_items', JSON.stringify([]));
    this.messagingService.sendComponentMessage("HEADER_UPDATE_NOTIFICATION_LIST", []);
  }

}
